import Axios from "axios"

export default {

  /**
   * 数据
   */
  data() {
    return Promise.all(
      [
        Axios.get(`${process.env.VUE_APP_PREFIX}/console/day/customer/view`),
        Axios.get(`${process.env.VUE_APP_PREFIX}/console/dayGroup/customer/view`)
      ]
    );
  }

}